export const global = [

    /**
     *  global JS for desktop site
     */

    /**
     *  for Production server
     */

    {
        'BASE_URL': getSubdomain(),
        'IMAGE_URL': "https://admin.callsteward.com/",
        'CLIENT_BASE': "callsteward.com/",
        'REPORT_URL': "https://reports.callsteward.com/"
    },

    /**
     * For staging server
     */

    // {
    //     'BASE_URL': "https://stage-callsteward.com/api/v2/",
    //     'IMAGE_URL': "https://stage-callsteward.com/",
    //     'CLIENT_BASE': "stage-callsteward.com/",
    //     'REPORT_URL': "https://reports.callsteward.com/"
    // },


    /**
     * for development server
     */
    // {
    //     'BASE_URL': "https://dev-callsteward.com/api/v2/",
    //     'IMAGE_URL': "https://dev-callsteward.com/",
    //     'CLIENT_BASE': "dev-callsteward.com/",
    //     'REPORT_URL': "https://reports.callsteward.com/"
    // },

    /**
     * Multi user association.
     */

    // {
    //     'BASE_URL': getSubdomain(),
    //     'IMAGE_URL': "https://callsteward.org/",
    //     'CLIENT_BASE': "callsteward.org/",
    //     'REPORT_URL': "https://reports.callsteward.org/"
    // },


    // {
    //     'BASE_URL': "https://callsteward.net/api/v2/",
    //     'IMAGE_URL': "https://callsteward.net/",
    //     'CLIENT_BASE': "callsteward.net/",
    //     'REPORT_URL':"https://reports.callsteward.com/"
    // },

    /**
     * for Admin CA server
     */

    // {
    //     'BASE_URL': "https://admin.callsteward.ca/api/v2/",
    //     'IMAGE_URL': "https://admin.callsteward.ca/",
    //     'CLIENT_BASE': "callsteward.ca/",
    //     'REPORT_URL': "https://reports.callsteward.com/"
    // },


    /**
     *  for Admin Uk server
     */

    // {
    //     'BASE_URL': "https://callsteward.uk/api/v2/",
    //     'IMAGE_URL': "https://callsteward.uk/",
    //     'CLIENT_BASE': "callsteward.uk/",
    //     'REPORT_URL':"https://reports.callsteward.com/"
    // },

    /**
     *  for local server
     */

    // {
    //     'BASE_URL': "http://localhost/cs3/api/v2/",
    //     'IMAGE_URL': "https://stage-callsteward.com/",
    //     'CLIENT_BASE': "stage-callsteward.com/"
    //     'REPORT_URL':"https://reports.callsteward.net/"
    // }

];

export function getSubdomain() {
    const subdomain = window.location.hostname.split('.')[0];
    console.log('subdomain: ', subdomain);
    const baseVar = "https://" + subdomain + ".callsteward.com/api/v2/";
    console.log('baseVar ', baseVar);
    return baseVar;
}




// WEBPACK FOOTER //
// ./src/global.js